var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconPaymentCard = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M5.175 12.75C4.761 12.75 4.425 12.414 4.425 12C4.425 11.586 4.761 11.25 5.175 11.25H9.07425C9.48825 11.25 9.82425 11.586 9.82425 12C9.82425 12.414 9.48825 12.75 9.07425 12.75H5.175Z", fill: "black" }),
            React.createElement("path", { d: "M1.5 18.75C1.5 19.164 1.836 19.5 2.25 19.5H21.75C22.164 19.5 22.5 19.164 22.5 18.75V5.25C22.5 4.836 22.164 4.5 21.75 4.5H2.25C1.836 4.5 1.5 4.836 1.5 5.25V18.75ZM3 9.75H21V18H3V9.75ZM21 8.25H3V6H21V8.25Z", fill: "black" }))),
        alt: 'Icon PaymentCard',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconPaymentCard;
//# sourceMappingURL=index.js.map